/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  KillswitchCapabilityKey,
  KillswitchCapabilityKey$outboundSchema,
} from "./killswitchcapabilitykey.js";
import {
  KillswitchSchedule,
  KillswitchSchedule$Outbound,
  KillswitchSchedule$outboundSchema,
} from "./killswitchschedule.js";
import {
  KillswitchScope,
  KillswitchScope$Outbound,
  KillswitchScope$outboundSchema,
} from "./killswitchscope.js";

export type KillswitchPreviewOverlapsRequest = {
  id?: string | undefined;
  schedule: KillswitchSchedule;
  scope: KillswitchScope;
  userId: string;
  capabilityKey: KillswitchCapabilityKey;
};

/** @internal */
export type KillswitchPreviewOverlapsRequest$Outbound = {
  id?: string | undefined;
  schedule: KillswitchSchedule$Outbound;
  scope: KillswitchScope$Outbound;
  user_id: string;
  capability_key: string;
};

/** @internal */
export const KillswitchPreviewOverlapsRequest$outboundSchema: z.ZodMiniType<
  KillswitchPreviewOverlapsRequest$Outbound,
  KillswitchPreviewOverlapsRequest
> = z.pipe(
  z.object({
    id: z.optional(z.string()),
    schedule: KillswitchSchedule$outboundSchema,
    scope: KillswitchScope$outboundSchema,
    userId: z.string(),
    capabilityKey: KillswitchCapabilityKey$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      userId: "user_id",
      capabilityKey: "capability_key",
    });
  }),
);

export function killswitchPreviewOverlapsRequestToJSON(
  killswitchPreviewOverlapsRequest: KillswitchPreviewOverlapsRequest,
): string {
  return JSON.stringify(
    KillswitchPreviewOverlapsRequest$outboundSchema.parse(
      killswitchPreviewOverlapsRequest,
    ),
  );
}
